var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aux"},[_c('div',{class:{ backgroundView: true, expanded: !_vm.sidebarMenuCollapsed, loadingScreen: _vm.$props.isLoading}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }